import React, { useCallback } from 'react';
import { Box } from '@common-fe/common-fe';

import { PERMISSIONS, ROUTES } from '@/common';
import { useHistory } from '@/modules/core';
import { Access } from '@/modules/core/components';
import Topbar from '@/modules/core/components/Topbar';
import { EnrollmentDetails } from '@/modules/employee/EnrollmentDetails/EnrollmentDetails';
import theme from '@/styles/theme';

const EnrollmentDetailsPage = () => {
  const history = useHistory();
  const goHome = useCallback(() => history.push(ROUTES.HOME), [history]);
  return (
    <Access
      accessRequirements={[
        {
          permission: PERMISSIONS.VIEW_PROFILE,
        },
      ]}
      accessDeniedAction={goHome}
    >
      <Box width="100%" margin={{ top: '0' }} height="fit-content">
        <Topbar />
        <Box align="center" pad={{ horizontal: '40px' }} margin={{ top: 'medium' }}>
          <Box width={theme.defaultContentWidth}>
            <EnrollmentDetails />
          </Box>
        </Box>
      </Box>
    </Access>
  );
};
export default EnrollmentDetailsPage;
